import { useEffect } from "react"

const BASE_URL = `${window.location.origin}`

export const useGetGroupId = (addGroupId: Function) => {
  useEffect(() => {
    if (BASE_URL.includes('charleshurst')) {
      return addGroupId(2)
    } else {
      return addGroupId(1)
    }
    // eslint-disable-next-line
  }, [])
}
